import './CustomView.css';

import React, { Component } from 'react';

import { Icon } from '../Icon';
import PropTypes from 'prop-types';

class CustomView extends Component {
  state = {
    open: false,
    left: '0px',
    top: '0px',
  };

  static propTypes = {
    titleElement: PropTypes.node,
    title: PropTypes.string,
    align: PropTypes.oneOf(['left', 'center', 'right']),
    /** Items to render in the select's drop down */
    list: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        icon: PropTypes.object,
        onClick: PropTypes.func,
        link: PropTypes.string,
      })
    ),
  };

  getListItems = () => {
    const { list } = this.props;

    return list.map(({ icon, title, link, onClick }, key) => {
      return (
        <a
          // href={link || '#!'}
          key={key}
          className="cv-item"
          onClick={() => this.handleOnClick(onClick)}
        >
          {icon && <Icon {...icon} className="cv-item-icon" />}
          <span>{title}</span>
        </a>
      );
    });
  };

  renderList = () => {
    const { left, top } = this.state;
    if (!this.state.open) {
      return null;
    }

    return (
      <div
        style={{
          position: 'fixed',
          left: left,
          top: top,
        }}
        className={`cv-menu-list right`}
      >
        {this.getListItems()}
      </div>
    );
  };

  handleOnClick = onClick => {
    this.toggleList();

    if (onClick) {
      onClick();
    }
  };

  handleMouseClick = e => {
    if (this.node.contains(e.target)) {
      return;
    }

    this.toggleList();
  };

  renderTitleElement = () => {
    const { titleElement, title } = this.props;

    if (titleElement) {
      return titleElement;
    }

    return (
      <React.Fragment>
        <span className="cv-title">{title}</span>
        {/* <span className="cv-caret-down" /> */}
      </React.Fragment>
    );
  };

  toggleList = e => {
    // e.currentTarget.parentElement.parentElement.style.zIndex = '100 !important';

    const { open } = this.state;
    let state = true;
    let offsetLeft, offsetTop;
    document.addEventListener('mousedown', this.handleMouseClick, false);

    if (open) {
      document.removeEventListener('mousedown', this.handleMouseClick, false);
      state = false;
      document.getElementsByClassName('vsticky')[0].classList.remove('vsticky');
    } else {
      let view = e.currentTarget.parentElement.parentElement;
      offsetLeft = (view.getBoundingClientRect().left - 90).toString() + 'px';
      offsetTop = (view.getBoundingClientRect().top + 40).toString() + 'px';
      view.className += ' vsticky';
    }

    this.setState({
      open: state,
      left: offsetLeft,
      top: offsetTop,
    });
  };

  render() {
    return (
      <div
        className="cv-menu"
        data-cy="options-menu"
        ref={node => (this.node = node)}
      >
        <div className="cv-menu-toggle" onClick={this.toggleList}>
          {this.renderTitleElement()}
        </div>

        {this.renderList()}
      </div>
    );
  }
}

export { CustomView };
